import { SVGProps } from 'react';

const ChartNoAxesColumn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 20V10m-6 10V4M6 20v-6"
    />
  </svg>
);
export default ChartNoAxesColumn;
